import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { editCustomRecords as deleteCustomRecords } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function deleteCustomTableRecords(
  params: TVariables,
): Promise<TResult> {
  const {
    accountId,
    lookupId,
    recordId,
    RemoveIfAssociationWithDeletedQuestion,
  } = params;
  const response = await fetch(
    deleteCustomRecords(
      accountId,
      lookupId,
      recordId,
      RemoveIfAssociationWithDeletedQuestion,
    ),
    {
      method: 'DELETE',
      headers: {
        Authorization: getTokenWithType(),
        'Content-Type': 'application/json',
      },
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: any;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
  lookupId: string;
  recordId: string;
  RemoveIfAssociationWithDeletedQuestion?: boolean;
};

type TSnapshot = unknown;

function useDeleteCustomRecords(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const deleteRecordResult = await deleteCustomTableRecords(params);
    if (deleteRecordResult.StatusCode === 200) {
      queryClient.invalidateQueries('custom_records');
      queryClient.invalidateQueries(['get_custom_table']);
    } else throw deleteRecordResult;
    return deleteRecordResult;
  });
}

export { useDeleteCustomRecords };
